import {
  HttpEvent,
  HttpInterceptor,
  HttpHandler,
  HttpRequest,
  HttpErrorResponse
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from '../environments/environment';
import { AppHttpError } from './_shared/models/models-index';

@Injectable({
  providedIn: 'root'
})
export class HttpErrorInterceptor implements HttpInterceptor {

  constructor(
    private router: Router
  ) { }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      catchError((error: HttpErrorResponse) => {
        let userFriendlyMessage = '';

        // Client-side error handling
        if (error.error instanceof ErrorEvent) {
          userFriendlyMessage = `Error: ${error.error.message}`;
        } else {
          // Server-side error handling
          const status = error.status;
          const statusText = error.statusText || 'Unknown Status';
  
          // Build custom message from the server error response
          const title = error.error?.title || 'Error Occurred';
          const detail = error.error?.detail || 'No additional details provided';
  
          userFriendlyMessage = `Error Code: ${status} (${statusText})\n${title}\n${detail}`;

          // Adjust message for FluentValidation errors
          if (status === 400 && error.error?.errors) {
            userFriendlyMessage = `Validation Error: ${JSON.stringify(error.error.errors)}`;
          }
        }

        // If unauthorized, clear user data and redirect to login.
        if (error.status === 401) {
          localStorage.removeItem('user');
          if (!!environment.loginRedirectUrl) {
            window.location.href = environment.loginRedirectUrl;
          } else {
            this.router.navigateByUrl('/login');
          }
        }

        // Construct an object with both error log and display properties.
        const formattedError: AppHttpError = {
          originalError: error,
          userFriendlyMessage
        };

        // Pass the formatted error downstream.
        return throwError(() => formattedError);
      })
    );
  }
}
